<template>
  <div class="content">
    <div class="content-box">
      <img style="width: 100%;height: auto;display: block;" :src="require('../../assets/'+appTheme+'/guzhenTop.jpg')" alt="" />
      <van-form @submit="onSubmit">
        <van-field
          v-model="coy_name"
          name="coy_name"
          label="企业名称"
          required
          placeholder="请输入企业名称"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="business_address"
          name="business_address"
          label="企业工商注册地址"
          required
          placeholder="请输入企业工商注册地址"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="brand_patent"
          name="brand_patent"
          label="申请使用商标产品专利"
          type="textarea"
          required
          :rules="[{ required: true, message: '' }]"
          placeholder="请输入申请使用商标产品专利"
        />
        <van-field
          v-model="brand_use_name"
          name="brand_use_name"
          label="申请使用商标产品名称"
          type="textarea"
          placeholder="请输入申请使用商标产品名称"
        />
        <van-field
          v-model="product_brand_name"
          name="product_brand_name"
          label="产品生产厂家名称"
          type="textarea"
          placeholder="请输入产品生产厂家名称"
        />
        <!--        <van-field-->
        <!--          readonly-->
        <!--          clickable-->
        <!--          name="picker"-->
        <!--          :value="valueCity"-->
        <!--          right-icon="arrow"-->
        <!--          label="产品生产厂家地址"-->
        <!--          placeholder="产品生产厂家地址"-->
        <!--          @click="showPickerCity = true"-->
        <!--        />-->
        <!--        <van-popup v-model="showPickerCity" position="bottom">-->
        <!--          <van-picker-->
        <!--            show-toolbar-->
        <!--            :columns="columnsCity"-->
        <!--            @confirm="onConfirmCity"-->
        <!--            @cancel="showPickerCity = false"-->
        <!--          />-->
        <!--        </van-popup>-->
        <van-field
          v-model="address_des"
          name="address_des"
          label="产品生产厂家地址"
          type="textarea"
          placeholder="请输入产品生产厂家地址"
        />
        <van-field
          v-model="telephone"
          name="telephone"
          label="产品负责人联系电话"
          placeholder="请输入产品负责人联系电话"
        />
        <div class="brand-box left-justifying" style="align-items: self-start;">
          <div class="title-name">
            产品图片
          </div>
          <div>
            <div class="left-justifying" style="align-items: self-start;">
              <van-uploader :preview-options="previewImage" :max-size="10000 * 1024" @oversize="onOversize" :after-read="afterReadMajor" :before-read="beforeRead" :before-delete="delMajor" v-model="fileListProduct" />
            </div>

          </div>
        </div>
        <div class="hint-license-box">
          <div class="hint-license">可上传多个产品图片</div>
        </div>
        <van-field
          v-model="video_src"
          name="video_src"
          label="产品视频(链接)"
          placeholder="产品视频(链接)"
        />
        <van-field
          v-model="product_sale_des"
          name="product_sale_des"
          label="产品卖点"
          type="textarea"
          placeholder="请输入产品卖点"
        />
        <van-field
          v-model="wholesale_price"
          name="wholesale_price"
          label="产品批发价"
          type="number"
          placeholder="请输入产品批发价">
          <template #button>
            <van-button style="background: #ffffff;color: #282828;border: none;" size="small" type="primary">元</van-button>
          </template>
        </van-field>
        <van-field
          v-model="retail_price"
          name="retail_price"
          label="产品建议零售价"
          type="number"
          placeholder="请输入产品建议零售价">
          <template #button>
            <van-button style="background: #ffffff;color: #282828;border: none;" size="small" type="primary">元</van-button>
          </template>
        </van-field>
        <!--        <div class="brand-box left-justifying" style="align-items: self-start;">-->
        <!--          <div class="title-name">-->
        <!--            产品买家客户画像-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <div class="left-justifying" style="align-items: self-start;">-->
        <!--              <van-uploader :preview-options="previewImage" :max-size="10000 * 1024" @oversize="onOversize" :after-read="afterReadPortrayal" :before-read="beforeRead" :before-delete="delPortrayal" v-model="fileListPortrayal" />-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="hint-license-box">-->
        <!--          <div class="hint-license">可上传多个产品买家客户画像</div>-->
        <!--        </div>-->
        <van-field
          v-model="pro_client"
          name="pro_client"
          label="产品买家客户画像"
          type="textarea"
          placeholder="请输入产品买家客户画像"
        />
        <div style="margin: 2.13333vw;padding: 5.33333vw 0 0">
          <van-button :disabled="isDisable" round block type="info" native-type="submit" style="background: #FDD80D;border-color: #FDD80D;color: #282828">提交</van-button>
        </div>
      </van-form>
      <div class="hint-box">数字灯云平台，经相关部门授权，为了把古镇灯饰的品牌效应赋能产业，帮助拥有自主知识产权的灯企能更具竞争力，现征集一批优秀的原创产品，授权“古镇灯饰”商标，通过地方平台销售，不仅能让买家更有信心，且平台还可以通过全球全域的方式宣传和推广入围产品，甚至通过《广东名优品牌企业》和“明人探厂”等途径向全球推介，为品牌发声。</div>
      <div class="hint-box" style="padding-top: 1.33333vw;padding-bottom: 2.66667vw;">
        <p>1、双方共同就全国市场尤其是美丽乡村工程中亮化项目、数字显示项目、数字宣传项目共同拓展。</p>
        <p>2、我方已经向古镇政府获取“古镇灯饰”商标授权，我们共同开拓行业的投标工程市场和订制性的工程项目</p>
      </div>
      <img style="width: 100%;height: auto;display: block;" src="../../assets/guzhen_bottom_coy.jpg" alt="" />
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import upLoaderImg from "../../api/upLoaderImg";
import { guZhenTrademarkAuth } from '@/api/company'
const jweixin = require('jweixin-module');
import Vue from 'vue';
import { Cascader } from 'vant';

Vue.use(Cascader);
import { Dialog } from 'vant';
import {getWechat} from "@/api/zhibo";
export default {
  name: "brandAuthorization",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      isDisable:false,
      codeNumber: '',
      apply_for_show: false,
      valueBusiness: '',
      columns: ['家具卷', '服装卷', '家电卷', '轻工、五金卷', '皮革卷','医疗器械化妆品卷', '陶瓷卷', '材料卷（建材）', '化工卷', '电子卷',
        '农产品卷','灯具照明卷', '珠宝卷', '饰品卷', '食品', '鞋业卷','酒店及酒店用品卷', '玩具游戏卷', '其它'],
      showPicker: false,
      areaList,
      value: '',
      showArea: false,
      valueCity:'', //  产品生产厂家地址 省市区
      address_des: '', // 产品生产厂家地址 des
      showPickerCity: false,
      columnsCity:[
        { text: "中山市", value: "101"},
        { text: "广州市", value: "102" },
        { text: "珠海市", value: "103" },
        { text: "深圳市", value: "104" },
        { text: "韶关市", value: "105" },
        { text: "汕头市", value: "106" },
        { text: "佛山市", value: "107" },
        { text: "江门市", value: "108" },
        { text: "湛江市", value: "109" },
        { text: "茂名市", value: "110" },
        { text: "肇庆市", value: "110" },
        { text: "惠州市", value: "111" },
        { text: "汕尾市", value: "112" },
        { text: "河源市", value: "113" },
        { text: "清远市", value: "114" },
        { text: "东莞市", value: "115" },
        { text: "潮州市", value: "116" },
        { text: "揭阳市", value: "117" },
        { text: "云浮市", value: "118" },
        { text: "梅州市", value: "119" },
      ],
      uploader: [{ url: 'https://img01.yzcdn.cn/vant/leaf.jpg' }],
      fileList: [],
      coy_name: '', // 企业名称
      business_address: '', //企业工商注册地址：
      brand_use_name:'', //  申请使用商标产品名称
      brand_patent:'', // 申请使用商标产品专利
      product_brand_name:'', // 产品生产厂家名称
      telephone: '',  // 产品负责人联系电话：
      fileListProduct: [], //  产品图片
      fileListProductUpload: [], // 产品图片接口返回图片
      video_src: '', // 产品视频
      product_sale_des: '', // 产品卖点
      wholesale_price: '', // 产品批发价
      retail_price:'', // 产品建议零售价
      fileListPortrayal: [],// 产品买家客户画像
      pro_client:'',// 产品买家客户画像
      fileListPortrayalUpload:[], // 调取接口的图片
      previewImage:{
        closeable: true,
      },
      product: {desc:'',image:[]},// 核心产品描述
      trademark: [], // 商标
      show: false,
      fieldValue: '',
      cascaderValue: '',
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: "广东省",
          value: "1",
          children: [
            {
              text: "中山市",
              value: "101",
              // children: [
              //   { text: "南山区", value: "10101" },
              //   { text: "宝安区", value: "10102" },
              //   { text: "龙华区", value: "10103" },
              //   { text: "福田区", value: "10104" },
              // ]
            },
            { text: "广州市", value: "102" },
            { text: "珠海市", value: "103" },
            { text: "深圳市", value: "104" },
            { text: "韶关市", value: "105" },
            { text: "汕头市", value: "106" },
            { text: "佛山市", value: "107" },
            { text: "江门市", value: "108" },
            { text: "湛江市", value: "109" },
            { text: "茂名市", value: "110" },
            { text: "肇庆市", value: "110" },
            { text: "惠州市", value: "111" },
            { text: "汕尾市", value: "112" },
            { text: "河源市", value: "113" },
            { text: "清远市", value: "114" },
            { text: "东莞市", value: "115" },
            { text: "潮州市", value: "116" },
            { text: "揭阳市", value: "117" },
            { text: "云浮市", value: "118" },
            { text: "梅州市", value: "119" },
          ],
        },
      ],
      infoData: '',
      pic:''
    };
  },
  created() {
    // this.getDesReport()
    let http = window.location.protocol+'//'
    let url = window.location.hostname // 获取当前访问（域名）
    this.pic = http+url+'/logo.jpg' //'https://jpzs-zst.itos.cn/logo.jpg'
    this.getShareInfo()
  },
  methods: {
    getShareInfo(){
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        // console.log('ios')
      } else {
        // console.log('安卓')
        pageUrl = location.href.split('#')[0]
      }

      const data = {
        liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
      }
      // console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          let weChat = res.data
          // console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['checkJsApi','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            const that = this
            // console.log('ready',that.desShare)
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              //是否支持分享
              jweixin.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
                success: function (res) {
                  console.log(res)
                }
              });
              let urlPath = location.href.split('#')[0]
              // alert("准备完毕，加载方法");
              //分享到朋友圈
              jweixin.updateTimelineShareData({
                title: '“古镇灯饰”商标申请授权',   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: '',   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              });
              jweixin.onMenuShareTimeline({ // 旧版本
                title: '“古镇灯饰”商标申请授权',   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: '',   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              })
              //分享给朋友
              jweixin.updateAppMessageShareData({
                title: '“古镇灯饰”商标申请授权',
                desc:' ',
                link: urlPath, // keyi
                imgUrl: '',
                success: function (n) {
                  console.log("分享成功", n);
                },
                complete: function (n) {
                  console.log(n);
                }
              });

              // 旧版本
              jweixin.onMenuShareAppMessage({
                title: '“古镇灯饰”商标申请授权', // 分享标题
                desc:' ', // 分享描述
                link: urlPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: '', // 分享图标
                success: function (e) {
                  // 用户点击了分享后执行的回调函数
                  console.log('分享给朋友',e);
                }
              });


            })
          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    closePreview(){
      console.log(22)
      this.$refs.licenseList.closeImagePreview()
    },
    goCheckPage(){
      this.$router.push('/applyFor'); // applyFor 选择界面
    },
    onConfirmCity(value){
      this.valueCity = value.text;
      this.showPickerCity = false;
      console.log(value.text)
    },
    getDesReport(){
      getCompanyReport().then(res => {
        console.log(res)
        this.infoData = res
        if (this.infoData != ''){
          var ceos = this.infoData.ceo.split(/[\s\n]/)
          this.ceo = ceos[0]
          this.sex_ceo = ceos[1]
          var founders = res.founder.split(/[\s\n]/)
          this.founder = founders[0]
          this.sex_founder = founders[1]
          this.name = res.name
          this.en_name = res.en_name
          this.valueCity = res.place
          this.address = res.address
          // this.major= res.major // 所属行业
          this.valueBusiness = res.number 	// 企业入编(行业) 卷号
          this.licenseImg = res.license
          this.licenseList = [{url:res.license}]

        }
      })
    },
    onConfirmBusiness(value) {
      this.valueBusiness = value;
      this.showPicker = false;
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join('/');
      console.log(this.fieldValue)
    },
    chooseSwitchover(){},
    onOversize(file) {
      console.log(file);
      this.$toast('文件大小不能超过 5000kb');
    },
    beforeRead (file) {	//上传之前校验
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$toast('只允许上传jpg/png格式的图片！')
        return false
      }
      return true
    },
    async afterReadMajor(file){ // 产品1
      console.log(file)
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        let imgItem = res.data.source_url
        // console.log('item',imgItem)
        let arr = this.fileListProductUpload
        arr.push(imgItem)
        this.fileListProductUpload = arr
        console.log('fileListProductUpload',arr)
      } else {
        this.$toast(message)
      }
    },
    delMajor(file, detail){ // 删除产品
      console.log('del',detail)
      this.$dialog.confirm({
        message: '确认删除图片？'
      }).then(() => {
        // 存放图片的数组
        this.fileListProduct.splice(detail.index, 1)
        this.fileListProductUpload.splice(detail.index, 1)
        this.$toast.success('删除成功')
      })
    },
    async afterReadPortrayal(file){ //  产品买家客户画像
      var data = {
        file: file.file
      }
      var res = await upLoaderImg(data) // 上传图片调用接口
      if (res.code==200){
        let imgItem = res.data.source_url
        let arr = this.fileListPortrayalUpload
        arr.push(imgItem)
        this.fileListPortrayalUpload = arr
      } else {
        this.$toast(message)
      }
    },
    delPortrayal(file, detail){ // 删除画像
      console.log('del',detail)
      this.$dialog.confirm({
        message: '确认删除图片？'
      }).then(() => {
        // 存放图片的数组
        this.fileListPortrayal.splice(detail.index, 1)
        this.fileListPortrayalUpload.splice(detail.index, 1)
        this.$toast.success('删除成功')
      })
    },
    clickPreview(file){
      console.log(file)
    },
    onConfirm(values) {
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/');
      this.showArea = false;
    },
    async onSubmit (e) { // 提交信息 // guZhenTrademarkAuth
      console.log(e)
      console.log('fileListProductUpload',this.fileListProductUpload)
      let data = {
        company_name: this.coy_name,
        company_address:this.business_address,
        brand_name:this.brand_use_name,
        brand_patent:this.brand_patent,
        factory_name: this.product_brand_name,
        factory_addess: this.address_des,
        telphone:this.telephone,
        images:this.fileListProductUpload,
        video:this.video_src,
        sale_desc:this.product_sale_des,
        market_price:this.wholesale_price,
        sale_price:this.retail_price,
        seler_image:this.pro_client
      }
      console.log('data',data)
      this.isDisable= true
      guZhenTrademarkAuth(data).then(res=>{
        if (res.code==200){
          this.isDisable= false
          this.$toast(res.message)
        } else {
          this.$toast(res.message)
          this.isDisable= false
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.popup-content{
  padding:20px 20px;width: 500px;
  .phone-txt{
    font-size: 28px;font-weight: 400;line-height: 50px;
  }
  .phone-num{
    font-size: 35px;color: red;font-weight: bold;margin-top: 30px;

  }
  .ok-btn{
    width: 80%;margin-top: 30px;
  }
}
.van-popup--center{
  border-radius: 15px;
}
/deep/.van-uploader__upload{
  width: 2.13333rem!important;
  height: 2.13333rem!important;
}
/deep/.van-field__label {color: #282828}
.zicon-img-box{
  //background: #ffffff;
  .zicon-img{
    width: 100%;height: auto;display: block;margin: 0 auto;
  }
}
.intellectual-box /deep/.van-field--min-height .van-field__control {
  min-height: 2.4rem;
}
.hint-license{
  padding-left:255px;text-align: left;border-bottom: 1.5px solid #ebedf0;padding-bottom: 15px;color: #282828;font-size: .31rem;
}
.hint-license-box{
  padding: 0 30px 0; margin-top: -10px;background: #ffffff;position: relative;
  //color: #ee0a24;
}
.major-box{
  padding: 20px 30px 0;background: #ffffff;position: relative;
  .major-box-uploader{

  }
}
.brand-box{
  padding: 20px 30px 10px;background: #ffffff;position: relative;text-align: left;
  .title-name{
    width: 252px;text-align: left;
    color: #282828;
  }
}
.hint-box{
  padding: 30px 30px 0;font-size: 26px;color: #282828;text-align: left;line-height: 60px;
}
.item-box{
  padding: 10px 30px 0;text-align: left;font-size: 26px;color: #333333;line-height:50px;
}
/deep/.van-field__label {
  width: 230px;
}
/deep/.van-uploader__upload {
  width: 1.75rem;height: 1.75rem;
}
.title{
  font-size: 32px;text-align: center;padding: 20px 0;font-weight: bold;
}
.van-field-box{
  background: #ffffff;position: relative;
  //border-bottom: 1px solid #ebedf0;
  .van-radio-group--horizontal{
    margin-left: 10px;
  }
  /deep/ .van-radio__label {
    margin-left: 5px;
  }
  /deep/ .van-radio--horizontal {
    margin-right: 12px;
  }
}
.van-field-box::after{
  content: '';
  width: 92%;height: 1px;background: #ebedf0; left: 3%;bottom: 2px;position: absolute;
}
</style>

